import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CenterFocusWeakIcon(props: IconProps) {
    return <Icon {...props} iconKey={"center_focus_weak"}/>
}
